import { render, staticRenderFns } from "./ScheduledMessageItem.vue?vue&type=template&id=27699257&scoped=true"
import script from "./ScheduledMessageItem.vue?vue&type=script&lang=js"
export * from "./ScheduledMessageItem.vue?vue&type=script&lang=js"
import style0 from "./ScheduledMessageItem.vue?vue&type=style&index=0&id=27699257&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27699257",
  null
  
)

export default component.exports